import { Routes } from '@angular/router';


export const ComponentsRoutes: Routes = [];
